module.exports = "/images/5b8f34c5a189e339684bad217bdcc2f7.png";